import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const req  = request.clone({
      setHeaders: {
       'X-Staysconnect-App-Id': environment.APP_ID,
       'X-Staysconnect-App-Key': environment.APP_KEY
      }
    });
    return next.handle(req);
  }
}
